module.exports = "/wp-content/plugins/farmacy/assets/js/images/flags@2x-e1c092e127943ec4289c847c5768b644.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/common/cart/img/flags@2x.png
 ** module id = 562
 ** module chunks = 1 9 15 91
 **/